import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Accordion disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

export function DiagnosticEditDocs() {
  return (
    <Stack gap={1}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {"Diagnose-Beschreibungen und Anweisungen pflegen — mit optionalen Überschreibungen pro Geotab-Gruppe."}
      </Typography>

      <Section title="Übersicht">
        <Typography variant="body2">
          {"Jede Zeile bildet eine Diagnose ab. Bearbeite die Felder Priorität, Beschreibung und Anweisung direkt in der Tabelle, um den Standard für alle Fahrzeuge festzulegen. " +
            "Der Standard erscheint im Diagnosemonitor und FaultMonitor, sofern keine passende Gruppen-Überschreibung existiert."}
        </Typography>
      </Section>

      <Section title="Gruppen-Überschreibungen">
        <Typography variant="body2">
          {"Manche Diagnosecodes bedeuten je nach Hersteller etwas anderes. " +
            "Über den Pfeil ganz links einer Zeile klappt sich der Bereich für Gruppen-Überschreibungen auf:"}
        </Typography>
        <Box component="ul" sx={{ pl: 2, my: 1 }}>
          <li>
            <Typography variant="body2">
              {'Mit "Gruppen-Überschreibung hinzufügen" eine Geotab-Gruppe auswählen und eigene Werte für Priorität, Beschreibung und Anweisung setzen.'}
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {"Fahrzeuge in dieser Gruppe sehen die Überschreibung statt des Standards."}
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {"Felder einer Überschreibung können bewusst leer bleiben — der angezeigte Text ist dann leer (kein Rückfall auf den Standard)."}
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {"Mülleimer-Icon entfernt die Überschreibung; der Standard wird wieder verwendet."}
            </Typography>
          </li>
        </Box>
      </Section>

      <Section title="Auflösung pro Fahrzeug">
        <Typography variant="body2">
          {"Beim Anzeigen einer Diagnose im Diagnosemonitor oder FaultMonitor wird pro Fahrzeug ausgewertet:"}
        </Typography>
        <Box component="ul" sx={{ pl: 2, my: 1 }}>
          <li>
            <Typography variant="body2">
              {"Hat das Fahrzeug eine Gruppe mit Überschreibung für diese Diagnose? Wenn ja, gewinnt die erste passende Überschreibung."}
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {"Andernfalls wird der Standard aus der Hauptzeile angezeigt."}
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {"Existiert weder Standard noch passende Überschreibung, bleibt das Feld leer."}
            </Typography>
          </li>
        </Box>
      </Section>
    </Stack>
  );
}
